import { MODAL_WIDTH_LG } from '../../../../../../styles/constants';
import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import {getFileMappingWizardPreviewRowListCsvRows, hideFileMappingWizardPreviewRowList, downloadTablePreview} from './actions';
import EnhancedModal from '../../../../../../components/enhanced-modal';
import {Button, Modal} from "antd";
import { getFilterObjFromViewerObj } from '../../../../../../utils/filter';
import InfiniteScrollDataTable from '../../../../../../components/infinite-scroll-data-table'
import DatasetDownloadForm from './DatasetDownloadForm';

const mapStateToProps = state => ({
  isVisible: state.scenes.dataManager.fileMapping.components.wizard.components.previewRowList.isVisible,
  isFixed: state.scenes.dataManager.fileMapping.components.wizard.components.previewRowList.isFixed,
  previewRows: state.scenes.dataManager.fileMapping.components.wizard.components.previewRowList.previewRows,
  tempTableName: state.scenes.dataManager.fileMapping.components.wizard.shared.tempTableName,
  FunctionFormData: state.scenes.dataManager.fileMapping.components.wizard.components.addField.FunctionFormData,
  csvHeader: state.scenes.dataManager.fileMapping.components.wizard.shared.csvHeader,
  checkedHeader: state.scenes.dataManager.fileMapping.components.wizard.shared.checkedHeader,
  addFieldModalEditMode: state.scenes.dataManager.fileMapping.components.wizard.components.addField.addFieldModalEditMode,
});

const mapDispatchToProps = dispatch => ({
  onHide: (tableName, aliasQuery, isEdit) => dispatch(hideFileMappingWizardPreviewRowList(tableName, aliasQuery, isEdit)),
  fetchCalcRows: (pageNum, pageSize, filterTable, sortCols, sortByDesc, functionQuery, aliasQuery, tableName, isFixed, checkedHeader, isEdit) =>
    dispatch(getFileMappingWizardPreviewRowListCsvRows(pageNum, pageSize, filterTable, sortCols, sortByDesc, functionQuery, aliasQuery, tableName, isFixed, checkedHeader, isEdit)),
  onDownload: (tableName, separator, delimiter, functionQuery, aliasQuery, checkedHeader, compression) => dispatch(downloadTablePreview(tableName, separator, delimiter, functionQuery, aliasQuery, checkedHeader, compression))
});

const FileMappingWizardPreviewRowList = ({
                                       t,
                                       isVisible,
                                       previewRows,
                                       onHide,
                                       fetchCalcRows,
                                       tempTableName,
                                       FunctionFormData,
                                       onDownload,
                                       isFixed,
                                       checkedHeader,
                                       addFieldModalEditMode,
                                     }) =>
  <EnhancedModal
    visible={isVisible}
    onCancel={() => onHide(tempTableName, FunctionFormData.nameValue, addFieldModalEditMode)}
    title={t('data.fileMapping.addField.preview.label')}
    width={MODAL_WIDTH_LG}
    footer={
      <div>
        <Button
          onClick={() => {
            let modal = Modal.info();
            modal.update({
              title: t("data.fileMapping.addField.downloadDataset.title"),
              content:
                <DatasetDownloadForm
                  t={t}
                  modal={modal}
                  onDownload={
                    (separator, delimiter, compression) =>
                    onDownload(tempTableName, separator, delimiter, FunctionFormData.functionValue, FunctionFormData.nameValue, checkedHeader, compression, addFieldModalEditMode)
                  }
                />,
              okButtonProps: {style: {display: 'none'}},
              cancelButtonProps: {style: {display: 'none'}},
              icon: 'download'
            })
          }}
          icon="download"
          type="primary"
          >
          {t('scenes.dataManager.fileMapping.wizard.download.label')}
        </Button>
        <Button onClick={() => onHide(tempTableName, FunctionFormData.nameValue, addFieldModalEditMode)}>
          {t('commons.buttons.close.title')}
        </Button>
      </div>
    }
  >
      <InfiniteScrollDataTable
        data={previewRows && previewRows.Data}
        rowTotal={previewRows && previewRows.Count}
        cols={previewRows && previewRows.Columns}
        hiddenCols={['NumRow']}
        onChange={
          ({pageNum, pageSize, searchText, filters, sortCol, sortByDesc}) => fetchCalcRows(
            pageNum,
            pageSize,
            getFilterObjFromViewerObj(
              previewRows && previewRows.Columns.filter(colName => colName !== 'NumRow'),
              searchText,
              filters
            ),
            sortCol ? [sortCol] : null,
            sortByDesc,
            FunctionFormData.functionValue,
            FunctionFormData.nameValue,
            tempTableName,
            isFixed,
            checkedHeader,
            addFieldModalEditMode
          )
        }
      />
  </EnhancedModal>;

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(FileMappingWizardPreviewRowList);
